import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query/react'
import { useFetchInfluencerInfoQuery } from '@/api/influencer-api'
import { usePermissions } from '@/hooks/use-permissions'
import type { InfluencerInfo } from '@/types/schema/influencer/influencer-info-schema'

type UseInfluencerInfo = (kolId?: string) => {
  influencerInfo?: InfluencerInfo
  isFetching: boolean
  isError: boolean
  error?: FetchBaseQueryError | SerializedError
}

const useInfluencerInfo: UseInfluencerInfo = (kolId) => {
  const { withKolPermission } = usePermissions()

  const {
    data: influencerInfo,
    isFetching: isFetchingInfluencerInfo,
    isError: isErrorToFetchInfluencerInfo,
    error: errorOfFetchInfluencerInfo,
  } = useFetchInfluencerInfoQuery(
    withKolPermission && kolId ? kolId : skipToken,
  )

  return {
    influencerInfo,
    isFetching: isFetchingInfluencerInfo,
    isError: isErrorToFetchInfluencerInfo,
    error: errorOfFetchInfluencerInfo,
  }
}

export default useInfluencerInfo
